import React, { useState } from "react";
import { HexColorPicker } from "react-colorful";

const SWATCHES = ["#9D4EDD", "#D4AF37", "#5CC8FF", "#E57373", "#4ADE80", "#F59E0B", "#EC4899", "#FFFFFF"];

export default function ColorPicker({ value = "#9D4EDD", onChange, label = "Colour code" }) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <label className="text-xs text-[#A19DB0]">{label}</label>
      <div className="flex items-center gap-2 mt-1">
        <button type="button" data-testid="color-panel-toggle" onClick={() => setOpen((o) => !o)}
          className="w-9 h-9 rounded-lg border border-white/20 shrink-0" style={{ background: value }} />
        <input value={value} onChange={(e) => onChange(e.target.value)} data-testid="color-hex-input" placeholder="#RRGGBB"
          className="flex-1 min-w-0 bg-white/5 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none focus:border-[#D4AF37]" />
      </div>
      <div className="flex gap-2 mt-2 flex-wrap">
        {SWATCHES.map((c) => (
          <button key={c} type="button" onClick={() => onChange(c)} data-testid={`swatch-${c}`}
            className={`w-6 h-6 rounded-full border-2 transition-transform active:scale-90 ${(value || "").toUpperCase() === c ? "border-white" : "border-transparent"}`} style={{ background: c }} />
        ))}
      </div>
      {open && (
        <div className="mt-3" data-testid="color-panel">
          <HexColorPicker color={value} onChange={onChange} style={{ width: "100%" }} />
        </div>
      )}
    </div>
  );
}
